import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FeatureDisplayChecklistItem } from 'pricing-pages-ui-components/components/merch-card/feature-display/FeatureDisplayChecklistItem';
import MerchCardLayout from 'pricing-pages-ui-components/layouts/merch-cards/MerchCardLayout';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { getHsocTierContent } from './HsocMerchCardContent';
import { HsocMerchCardBadge } from './HsocMerchCardBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CARD_STYLES = {
  paddingInline: '600',
  backgroundColor: 'fill-surface-default',
  borderRadius: '400',
  borderStyle: 'solid',
  borderColor: 'border-core-subtle',
  borderWidth: '100'
};
const PriceAmountWrapper = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "span",
  typography: "body-700",
  "data-style": "font-weight-500",
  color: "text-core-default",
  children: children
});
export const HsocMerchCard = ({
  columnStart,
  tierApiName,
  tierName,
  price,
  features,
  ctas,
  badge
}) => {
  const {
    title,
    subheading,
    featuresHeading
  } = getHsocTierContent(tierName);
  const Title = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-400",
        marginBlockStart: "0",
        children: title
      }), badge && /*#__PURE__*/_jsx(HsocMerchCardBadge, {
        badge: badge
      })]
    })
  });
  const Subheading = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "50",
    children: /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-100",
      color: "text-core-subtle",
      children: subheading
    })
  });
  const Pricing = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "400",
    children: price ? /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      color: "text-core-subtle",
      "data-style": "line-height-xs",
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: price.price,
        currencyCode: price.currencyCode,
        showPricePerMonthPerSeat: tierName !== 'FREE',
        seleniumId: `${tierApiName}-price`,
        PriceWrapper: PriceAmountWrapper
      })
    }) : null
  });
  const CTAs = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "500",
    children: ctas
  });
  const Features = /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: "600",
    paddingBlockEnd: "600",
    children: [features.length > 0 && /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "heading-50",
      marginBlockStart: "0",
      marginBlockEnd: "300",
      children: featuresHeading
    }), features.map(feature => /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FeatureDisplayChecklistItem, {
        message: feature.label,
        isAvailable: feature.isAvailable !== false
      })
    }, feature.key))]
  });
  return /*#__PURE__*/_jsx(MerchCardLayout, {
    "data-selenium-id": `${tierApiName}-merch-card`,
    columnStart: columnStart,
    Title: Title,
    Subheading: Subheading,
    Pricing: Pricing,
    CTAs: CTAs,
    Features: Features,
    cardStyles: CARD_STYLES
  });
};